import { Navigate, Outlet } from 'react-router-dom';
import { useAuth } from '../auth/useAuth';

/** UX gate only — the real boundary is the backend's PlatformAdminGuard (ADR-0006). */
export default function AdminRoute() {
  const { user } = useAuth();
  if (!user?.isPlatformAdmin) return <Navigate to="/" replace />;
  return <Outlet />;
}
